import { css } from '@emotion/react';
import { useMemo } from '@wordpress/element';
import { contextConnect, ContextSystemProvider } from '../../context';
import { Elevation } from '../../elevation';
import { View } from '../../view';
import * as styles from '../styles';
import { useCard } from './hook';
import CONFIG from '../../utils/config-values';
import { useCx } from '../../utils/hooks/use-cx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function UnconnectedCard(props, forwardedRef) {
  const {
    children,
    elevation,
    isBorderless,
    isRounded,
    size,
    ...otherProps
  } = useCard(props);
  const elevationBorderRadius = isRounded ? CONFIG.radiusLarge : 0;
  const cx = useCx();
  const elevationClassName = useMemo(() => cx(/*#__PURE__*/css({
    borderRadius: elevationBorderRadius
  }, process.env.NODE_ENV === "production" ? "" : ";label:elevationClassName;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")), [cx, elevationBorderRadius]);
  const contextProviderValue = useMemo(() => {
    const contextProps = {
      size,
      isBorderless
    };
    return {
      CardBody: contextProps,
      CardHeader: contextProps,
      CardFooter: contextProps
    };
  }, [isBorderless, size]);
  return /*#__PURE__*/_jsx(ContextSystemProvider, {
    value: contextProviderValue,
    children: /*#__PURE__*/_jsxs(View, {
      ...otherProps,
      ref: forwardedRef,
      children: [/*#__PURE__*/_jsx(View, {
        className: cx(styles.Content),
        children: children
      }), /*#__PURE__*/_jsx(Elevation, {
        className: elevationClassName,
        isInteractive: false,
        value: elevation ? 1 : 0
      }), /*#__PURE__*/_jsx(Elevation, {
        className: elevationClassName,
        isInteractive: false,
        value: elevation
      })]
    })
  });
}

/**
 * `Card` provides a flexible and extensible content container.
 * `Card` also provides a convenient set of sub-components such as `CardBody`,
 * `CardHeader`, `CardFooter`, and more.
 *
 * ```jsx
 * import {
 *   Card,
 *   CardHeader,
 *   CardBody,
 *   CardFooter,
 *   __experimentalText as Text,
 *   __experimentalHeading as Heading,
 * } from `@wordpress/components`;
 *
 * function Example() {
 *   return (
 *     <Card>
 *       <CardHeader>
 *         <Heading level={ 4 }>Card Title</Heading>
 *       </CardHeader>
 *       <CardBody>
 *         <Text>Card Content</Text>
 *       </CardBody>
 *       <CardFooter>
 *         <Text>Card Footer</Text>
 *       </CardFooter>
 *     </Card>
 *   );
 * }
 * ```
 */
export const Card = contextConnect(UnconnectedCard, 'Card');
export default Card;